<div class="flex align-center justify-center full-width position-relative top-bar">
    <app-logo [logo]="logo" [alt]="alt"></app-logo>

    <button
        *ngIf="(['stores.view-any', 'auth-logs.view-any'] | can) && user?.settings?.bf2_password_pin"
        type="button"
        class="d-flex align-items-center justify-content-center back-to-sales"
        title="Back to Sales"
        (click)="redirect()"
    >
        <i class="fa-solid fa-home" aria-hidden="true"></i>
    </button>
</div>
